<!--<c-footer>-->
  <div>
    <a class="unit btn btn-link" *ngIf="unitName && orgLink" [routerLink]="['/organizations']">
      <i class="fas fa-university"></i> {{ unitName }}
    </a>
  </div>
  <div class="ms-auto d-none d-sm-none d-md-none d-lg-flex">
    <a target="_blank" href="https://ladder.dev.br">Ladder Tecnologia </a>
    &nbsp; &copy; 2010 - {{ currentDate.getFullYear() }}
  </div>
<!--</c-footer>-->
